import { z } from 'zod';

import { PaginationResponseSchema } from '@/shared/global.schema';

export const SalesReturnItemSchema = z.object({
    id: z.string(),
    created_at: z.string().datetime(),
    updated_at: z.string().datetime(),
    sales_return_id: z.string(),
    product_variation_id: z.string().nullable(),
    product_name: z.string(),
    price: z.number().min(0),
    quantity: z.number().min(0),
    rate: z.number().min(0),
});

export const SalesReturnSchema = z.object({
    id: z.string(),
    created_at: z.string().datetime(),
    updated_at: z.string().datetime(),
    user_id: z.string(),
    payment_id: z.string(),
    order_id: z.string(),
    invoice_number: z.string(),
    items: z.array(SalesReturnItemSchema),
    user: z.any().optional(),
});

export const ResponseSalesReturnSchema = z.object({
    data: SalesReturnSchema,
});

export type SalesReturnSchemaType = z.infer<typeof SalesReturnSchema>;
export type SalesReturnItemSchemaType = z.infer<typeof SalesReturnItemSchema>;

export const ResponseSalesReturnsSchema = z.object({
    data: z.array(SalesReturnSchema),
    pagination: PaginationResponseSchema,
});

export type SalesReturnsSchemaType = z.infer<typeof ResponseSalesReturnsSchema>;
